import InfoService from '@/service/InfoService.js'

export default class BasicoService extends InfoService {

  constructor(ref) {
    super(ref)
  }

  category(id) {
    let url = `${super.baseUrl}category/${id}`
    return super.customGet(url)
  }

  categoryList(page) {
    let url = `${super.baseUrl}category`
    let params = {
      page: page
    }
    return super.customGet(url, params)
  }

  categorySave(dto) {
    let url = ''
    if (dto.id > 0) {
      url = `${super.baseUrl}category/${dto.id}`
    } else {
      url = `${super.baseUrl}category`
    }
    return super.customPut(url, dto)
  }

  categoryDelete(id) {
    let url = `${super.baseUrl}category/${id}`
    return super.customDelete(url)
  }

  videoList(id, name, page) {
    let url = `${super.baseUrl}video`
    let params = {
      page: page,
      category_id: id,
      name: name
    }
    return super.customGet(url, params)
  }

  videoSave(videoId, dto) {
    let url = ''
    if (videoId > 0) {
      url = `${super.baseUrl}video/${videoId}`
    } else {
      url = `${super.baseUrl}video`
    }
    return super.customPost(url, dto, 'multipart/form-data')
  }

  videoDelete(id) {
    let url = `${super.baseUrl}video/${id}`
    return super.customDelete(url)
  }

  videoExport(id, type) {
    let url = `${super.baseUrl}video/${id}/export/${type}`
    return super.customGetDownload(url)
  }

  getVideoExportUrl(id, type) {
    return `${super.baseUrl}video/${id}/export/${type}`
  }
}



// WEBPACK FOOTER //
// ./src/service/BasicoService.js